import { webStyleRegistry as _webStyleRegistry, type IStyleRegistry } from '@vp/ubik-context'

export const webStyleRegistry = (): IStyleRegistry => {
  if (_webStyleRegistry) {
    // ubik-context will provide a default style registry
    // in a upcoming version
    return _webStyleRegistry()
  }

  // Fallback to the old implementation
  return {
    insertCss: () => () => {},
    getStyles: () => [],
  }
}
